// 買い物リスト
import NativeClient from "@/client/native-client";
import {
  ShoppingListUncheckedFoodListItem,
  ShoppingListCategoryListItem
} from "@/types/shoppingList";

// 食品カテゴリ別のリストに変換する
export const translateCategoryList = (list: Array<ShoppingListUncheckedFoodListItem>) => {
  const result: Array<ShoppingListCategoryListItem> = [];
  for (const item of list) {
    const element = new ShoppingListCategoryListItem();
    element.categoryName = item.categoryName;
    for(const foodItem of item.items) {
      element.foodList.push(foodItem);
    }
    result.push(element);
  }
  return result;
};
